import type React from 'react'
import { useState } from 'react'

import { useAutosizeTextArea } from '@/hooks'
import { clsJoin } from '@/utils'
import { FormLabel } from '../FormLabel'
import css from './styles.module.css'

interface Props {
  name: string
  label: string
  value: string
  canEdit: boolean
  readOnly: boolean
  counterText?: string
  cnClassName: string
  counterClassName?: string
  onChange: (value: string) => void
  onBlur: () => void
}

export const FormTextarea: React.FC<Props> = ({
  name,
  label,
  value,
  canEdit,
  readOnly,
  counterText,
  cnClassName,
  counterClassName,
  onChange,
  onBlur,
}) => {
  const [showCounter, setShowCounter] = useState(false)
  const [textAreaRef, setTextAreaRef] = useState<HTMLTextAreaElement | null>(
    null
  )

  useAutosizeTextArea(textAreaRef, value)

  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.currentTarget.value)
  }

  const handleFocus = () => {
    setShowCounter(true)
  }

  const handleBlur = () => {
    setShowCounter(false)
    onBlur()
  }

  const disabled = !canEdit || readOnly

  return (
    <div className={clsJoin(css.form_textarea, cnClassName)}>
      <FormLabel
        name={name}
        label={label}
        showCounter={showCounter}
        counterText={counterText}
        counterClassName={counterClassName}
      />

      <textarea
        ref={setTextAreaRef}
        id={name}
        name={name}
        className={clsJoin(css.form_textarea_field, disabled && css.disabled)}
        value={value}
        readOnly={readOnly}
        disabled={disabled}
        onChange={handleOnChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  )
}
